import {Box} from '@mui/material';
import './SimilarityScore.scss';

interface SimilarityScoreProps {
  score: number;
  dataTestId: string;
  children?: React.ReactNode;
}

const RADIUS = 9;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const getColor = (score: number) => {
  if (score >= 0.8) return '#7DDFBB';
  if (score >= 0.51) return '#FFC37D';
  return '#FF7A7A';
};

const SimilarityScore: React.FC<SimilarityScoreProps> = ({
  score,
  dataTestId,
  children,
}) => {
  const progress = score * CIRCUMFERENCE;

  return (
    <Box className="similarity-score-wrapper">
      <svg
        className="similarity-score-component-wrapper"
        viewBox="0 0 24 24"
        data-testid={`similarity-score-svg-${dataTestId}`}
      >
        <circle
          className="similarity-score__bg"
          cx="12"
          cy="12"
          r={RADIUS}
          data-testid={`similarity-score-bg-circle-${dataTestId}`}
        />

        <circle
          className="similarity-score__fg"
          cx="12"
          cy="12"
          r={RADIUS}
          stroke={getColor(score)}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={CIRCUMFERENCE - progress}
          data-testid={`similarity-score-fg-circle-${dataTestId}`}
        />
      </svg>
      {children && (
        <span
          className="typo-text body3_size"
          data-testid={`similarity-score-children-${dataTestId}`}
        >
          {children}
        </span>
      )}
    </Box>
  );
};

export default SimilarityScore;
